import { all } from 'redux-saga/effects';
import workflowSaga from './workflowSaga';

const Sagas = function* () {
  yield all([
    workflowSaga(),
  ]);
};

export default Sagas;
